import { render, staticRenderFns } from "./statisticStore.vue?vue&type=template&id=3fb9483c&scoped=true"
import script from "./statisticStore.vue?vue&type=script&lang=js"
export * from "./statisticStore.vue?vue&type=script&lang=js"
import style0 from "./statisticStore.vue?vue&type=style&index=0&id=3fb9483c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9483c",
  null
  
)

export default component.exports